import React, { useMemo } from "react";

import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import isNil from "lodash/isNil";
import { NumericFormat } from "react-number-format";
import Flx from "../layout/Flx";

const PercentInput = ({
  value,
  onChange,
  fullWidth = true,
  sx,
  size = "medium",
  disabled,
  onBlur,
  placeholder = "Enter percentage",
  inputParams,
  showSlider = false,
  sliderProps = {},
  sliderMin = 0,
  sliderMax = 1,
  // sliderStep = 0.001,
  sliderStep = 0.05,
  ...rest
}) => {
  const styles = useMemo(() => {
    return {
      ...sx,
    };
  }, [sx]);

  const handleSliderChange = (event, newValue) => {
    onChange(newValue);
  };

  const sliderValue = useMemo(() => {
    if (isNil(value) || value === "") return sliderMin;
    return Math.min(Math.max(value, sliderMin), sliderMax);
  }, [value, sliderMin, sliderMax]);

  const textFieldComponent = (
    <TextField
      className="percent-input"
      value={value ?? ""}
      onChange={onChange}
      placeholder={placeholder}
      size={size}
      onBlur={onBlur}
      fullWidth={!showSlider && fullWidth}
      sx={styles}
      disabled={disabled}
      InputProps={{
        inputComponent: NumberFormatCustom,
      }}
      {...inputParams}
      {...rest}
    />
  );

  if (!showSlider) {
    return textFieldComponent;
  }

  return (
    <Flx ac fw={fullWidth} g={2} sx={{ width: "100%" }}>
      <Slider
        value={sliderValue}
        onChange={handleSliderChange}
        min={sliderMin}
        max={sliderMax}
        step={sliderStep}
        disabled={disabled}
        valueLabelDisplay="auto"
        valueLabelFormat={(val) => `${(val * 100).toFixed(1)}%`}
        {...sliderProps}
      />
      {textFieldComponent}
    </Flx>
  );
};

const NumberFormatCustom = React.forwardRef(
  function NumberFormatCustom(props, ref) {
    const { input, inputRef, onChange, value, ...other } = props;

    return (
      <NumericFormat
        {...other}
        suffix="%"
        decimalSeparator="."
        decimalScale={3}
        fixedDecimalScale={false}
        onValueChange={(values) => {
          const { floatValue } = values;

          if (floatValue === undefined) {
            onChange(undefined);
            return;
          }
          const converted = (floatValue / 100).toFixed(5);
          onChange(Number(converted));
        }}
        value={isNil(value) || value === "" ? null : (value * 100).toFixed(3)}
        valueIsNumericString={value !== null && value !== undefined}
        getInputRef={ref || inputRef}
      />
    );
  }
);

export default PercentInput;
